import { NextRouter } from 'next/router';

import { ProfileGroupProductPageRedirects } from '@sitecore/types/WarmthCheckAddressFinder';

export const navigateToProfileGroup = (
  router: NextRouter,
  profileGroup: number,
  redirects: ProfileGroupProductPageRedirects,
) => {
  const profileLinkKey = `profile${profileGroup}Link` as keyof ProfileGroupProductPageRedirects;
  const profileLink = redirects[profileLinkKey]?.value?.href;
  if (profileLink) router.push(profileLink);
};
